import { createPrivateKeyStorage } from '@orionprotocol/storage';

import { cookieStorage } from './defaultCookeStorage';
import { keyValueStorage } from './defaultKeyValueStorage';

export const privateKeyStorage = createPrivateKeyStorage([
  keyValueStorage,
  cookieStorage,
]);
